/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { useSelector } from 'react-redux';
import {
  selectAllAssignedPermissions,
  selectResourcePermissions
} from '../../store/auth/authSelector';
import { checkResourcePermission, checkPermission} from './CheckPermission';
export const CheckViewPermission = (props: { permission: string[]; children: any }) => {
  const assignedPermissions = useSelector(selectAllAssignedPermissions);
  const hasPermission =
    assignedPermissions &&
    assignedPermissions.permissions &&
    checkPermission(props.permission, assignedPermissions.permissions);
  return hasPermission ? props.children : '';
};

export const CheckResourcePermissions = (props: { action: string; resource: string; children: any }) => {
  const assignedPermissions = useSelector(selectResourcePermissions);
  const hasPermission =
      assignedPermissions &&
      assignedPermissions.resources &&
      checkResourcePermission(props.action, assignedPermissions.resources[props.resource]);
  return hasPermission ? props.children : '' ;
}
